import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";

export default observer(function PopupHeader(props: {
	slipNumber: number;
	isLive: boolean;
	BBPick: BetBuilderPick;
	cb: () => void;
}) {
	const { t } = useTranslation();

	return (
		<div className="popup__header popup--qp__header popup--bbp__header">
			<div className="popup__title">
				<i className="u-icon u-icon--xmed u-icon--bb--active" />
				<div className="popup__title__inner">
					{props.slipNumber != null && (
						<div className="popup__title__inner">
							{t("QUICK_PLAY.BET_BUILDER_PICKS.BB_CARD_TITLE")} #
							{props.slipNumber + 1}
						</div>
					)}
				</div>
				{props.isLive && (
					<span className="popup__tag tag tag--base tag--live--ghost tag--bolder">
						{t<string>("COMMON.LIVE")}
					</span>
				)}
			</div>
			<button
				type="button"
				onClick={props.cb}
				className="popup__close btn btn--square btn--square--xsml btn--primary--inverted"
				title={t("COMMON.CLOSE")}
			>
				<i className="u-icon u-icon--tny u-icon--close" />
			</button>
		</div>
	);
});
